package com.exura.features.plandefinition.data.remote.dto.collection

import com.exura.features.firebase.data.remote.dto.SerializableDto
import kotlinx.serialization.Serializable

@Serializable
data class CollectionDto(
    val name: String,
    val description: String,
    val relativeDay: Int = 0,
    val imageUrl: String? = null,
    val durationInDays: Int? = null
) : SerializableDto
